/*--------------------------------------------------------------------------------------------
Program     :  PriorityWebSDKService.js
Description :  Main program for Map and Track WebSDKService
Date        :  29/08/2024 
Created By  :  Fode/Jelbin
---------------------------------------------------------------------------------------------
TicketNo         Author          Date            ChangeDesc
---------------------------------------------------------------------------------------------
29082024        - Fode/Jelbin     -  29/08/2024        Created
---------------------------------------------------------------------------------------------*/
import { useState, useEffect } from 'react';
import * as sdk from 'priority-web-sdk';

const PriorityWebSDKService = ({ setChooseOptions, editablefield, selectedSourceMain,
    envFileData, mapVisibilityDate, tableUniqueName, tableUniqueValue,
    selectedChooseData, changeChooseData }) => {

    const [formData, setFormData] = useState(null);

    useEffect(() => {
        const initializePriority = async () => {
            console.log("initializePrioritySDK", tableUniqueValue,envFileData.COMPANY);
            try {
                const loginData = {
                    username: envFileData.PRIORITY_API_USERNAME,
                    password: envFileData.PRIORITY_API_PASSWORD,
                    url: envFileData.WEBSDKURL, //'https://proxy.clarksonevans.co.uk:8443/wcf/wcf/Service.svc',
                    tabulaini: 'tabula.ini',
                    language: 2,
                    profile: {
                        company: envFileData.COMPANY
                    }
                };
                await sdk.login(loginData);
                
                const formConfig = {
                    formName: selectedSourceMain,
                    profile: { company: envFileData.COMPANY, group: 0 },
                    autoRetriveFirstRows: 2,
                };

                const form = await sdk.formStart(
                    formConfig.formName,
                    formConfig.profile,
                    formConfig.autoRetriveFirstRows
                );
                setFormData(form);
                // Run the form in search mode for selected task
                const searchFilter = {
                    or: 0,  // AND operator
                    ignorecase: 1,
                    QueryValues: [{
                        field: tableUniqueName[0], // Form Unique Field
                        fromval: tableUniqueValue, // Selected Unique Value
                        toval: "",
                        op: "=",
                        sort: 1,
                        isdesc: 0
                    }]
                };
                await form.setSearchFilter(searchFilter);

                const rows = await form.getRows(1);

                let chooseLinesData = {};
                for (let item of editablefield) {
                    const columnval = item.NAME;

                    if (!chooseLinesData[columnval]) {
                        chooseLinesData[columnval] = [];
                    }
                    for (let column in form.columns) {
                        if (column === columnval && form.columns[column].zoom === "Choose") {
                            const chooseResult = await form.choose(columnval, "");
                            console.log("chooseResult", chooseResult);
                            if (chooseResult?.ChooseLine) {
                                chooseLinesData[columnval] = chooseResult.ChooseLine.map(item => ({
                                    string1: item.string1
                                }));
                            }
                            break;
                        }
                    }
                }
                setChooseOptions(chooseLinesData);

            } catch (error) {
                console.error('Priority initialization error:', error);
            }
        };

        initializePriority();
    }, [tableUniqueValue]);

    return null;
};

export default PriorityWebSDKService;